var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-page',{attrs:{"header":_vm.$tc(_vm.$translate.LearningRequests)},scopedSlots:_vm._u([{key:"content",fn:function(){return [(_vm.requests.length)?_c('imported-users-orders',{attrs:{"requests":_vm.requests}}):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }